import { render } from "./ChatComp.vue?vue&type=template&id=044fde0c&scoped=true"
import script from "./ChatComp.vue?vue&type=script&lang=js"
export * from "./ChatComp.vue?vue&type=script&lang=js"

import "./ChatComp.vue?vue&type=style&index=0&id=044fde0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044fde0c"]])

export default __exports__